import constants from 'constants/constants';
import moment from 'moment-timezone';

export const formatNameForUplodaedFile = (firstName: string | undefined, lastName: string | undefined): string => {
    const firstNameLastName = ` ${firstName ?? ''} ${lastName ?? ''}`.trim();
    return `${moment().format(constants.formats.date.defaultWithTime)}`
        .concat(` ${firstNameLastName}`)
        .trim()
        .split(' ')
        .join('_');
};
